var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { Loader } from '@pinwheel/origami';
import { useLoaderConfig } from '../../theme';
/**
 * Hook for calculating style and text to be used. Maintains vertical height by
 * setting a non-breaking space character.
 */
var useTextAndStyle = function (textIn) {
    return useMemo(function () { return ({
        style: {
            height: '100%',
        },
        text: textIn || '\u00a0',
    }); }, [textIn]);
};
var Loading = function (_a) {
    var textIn = _a.text;
    var loaderConfig = useLoaderConfig();
    var _b = useTextAndStyle(textIn), text = _b.text, style = _b.style;
    return (React.createElement("div", { "data-testid": "loading", "aria-busy": true, "aria-label": "Loading", style: style }, loaderConfig && (React.createElement(Loader, __assign({ sx: __assign(__assign(__assign({}, ('width' in loaderConfig && { width: loaderConfig.width })), ('height' in loaderConfig && { height: loaderConfig.height })), { 
            // fixes an IE11 issue which causes the loader to overlap the modal container's background color
            zIndex: -1 }), text: text }, loaderConfig)))));
};
export default Loading;
